import type {Component, Editor} from 'grapesjs';
import type {CanvasDevice} from '@FormMakerReact/form-maker.types';

export function getSelectedComponent(editor: Editor): Component | null {
  return editor.getSelected() ?? null;
}

export function getComponentType(component: Component): string {
  const value: unknown = component.get('type');
  return typeof value === 'string' ? value : '';
}

export function selectComponent(editor: Editor, component: Component | null): void {
  editor.select(component ?? undefined);
}

export function undo(editor: Editor): void {
  editor.UndoManager.undo();
}

export function redo(editor: Editor): void {
  editor.UndoManager.redo();
}

export function canUndo(editor: Editor): boolean {
  return editor.UndoManager.hasUndo();
}

export function canRedo(editor: Editor): boolean {
  return editor.UndoManager.hasRedo();
}

export function setCanvasDevice(editor: Editor, device: CanvasDevice): void {
  editor.setDevice(device);
}

// Keymaps are bound to the iframe's contentWindow; focusing it routes subsequent keystrokes to GrapesJS.
export function focusCanvas(editor: Editor): void {
  editor.Canvas.getFrameEl()?.contentWindow?.focus();
}
